var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.657.01C1.093.01-.691 4.319 1.828 6.838l20.344 20.344c2.52 2.52 6.828.735 6.828-2.829V4.01a4 4 0 0 0-4-4H4.657Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTail);
export default __webpack_public_path__ + "static/media/messageTail.9a7b30d5b5f069fdae12a41f7e6f505b.svg";
export { ForwardRef as ReactComponent };